import { render, staticRenderFns } from "./add-score-dialog.vue?vue&type=template&id=2b7707d5&scoped=true&"
import script from "./add-score-dialog.vue?vue&type=script&lang=js&"
export * from "./add-score-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-score-dialog.vue?vue&type=style&index=0&id=2b7707d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7707d5",
  null
  
)

export default component.exports